export const right_answer={"Да":true, "1.Да":true, [true]:true}

export const answerCollection={[true]:"1",[false]:"0",[null]:""}

export const answerVisual={[true]:"1.Да", [false]:"0.Нет"}